import SignUp from 'src/components/SignUp/SignUp';
import { connect } from 'react-redux';
import { CustomerActionCreator, FrameworkActionCreator, VehiclesActionCreator, AppointmentActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    customerInfo: state.Customer.Customer,
    apptCust: state.Appointment.ApptCust ?? '',
    errMsg: state.Customer!.errMsg,
    profileNum: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    previewFlag: state.Framework.previewFlag,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    identityVerified: state.Customer.identityVerified,
    mfaContact: state.Customer.mfaContact,
    mfaEnabled: state.Specs.specs?.mfaEnabled,
    viewMode: state.Framework.viewMode,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
    theme: state.Framework.theme,
    specData: state.Specs.specs,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    createAccount: CustomerActionCreator.CreateAccount,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    clearError: CustomerActionCreator.CustomerClearError,
    onLogin: CustomerActionCreator.LoginCustomer,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    getVehicles: VehiclesActionCreator.GetVehicles,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    sendResetEmail: CustomerActionCreator.SendResetEmail,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    setApptHistId: AppointmentActionCreator.SetApptHistId,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SignUp);